// src/api/declarationService.js
import { getCookieValue } from '../api/cookie';
const API_URL = process.env.REACT_APP_API_URL || "";

/** Minimal helpers for GET/POST with JSON */
async function getJson(endpoint) {
  const csrfToken = getCookieValue('csrf_token');
  const res = await fetch(`${API_URL}${endpoint}`, {
    credentials: 'include',
    headers: { 'X-CSRFToken': csrfToken },
  });
  const data = await res.json();
  if (!res.ok) {
    const error = new Error(data.error || 'Request failed');
    error.responseData = data; // Store the full response data
    throw error;
  }
  return data;
}

export async function postJson(endpoint, payload = {}) {
  const csrfToken = getCookieValue('csrf_token')
  const res = await fetch(`${API_URL}${endpoint}`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRFToken' : csrfToken
    },
    body: JSON.stringify(payload),
  });
  const data = await res.json();
  if (!res.ok) {
    const error = new Error(data.error || 'Request failed');
    error.responseData = data; // Store the full response data
    throw error;
  }
  return data;
}

async function patchJson(endpoint, payload = {}) {
  const csrfToken = getCookieValue('csrf_token');
  const res = await fetch(`${API_URL}${endpoint}`, {
    method: 'PATCH',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRFToken': csrfToken
    },
    body: JSON.stringify(payload),
  });
  const data = await res.json();
  if (!res.ok) {
    const error = new Error(data.error || 'Request failed');
    error.responseData = data; // Store the full response data
    throw error;
  }
  return data;
}

// 1) Fetch distinct publication dates
export function fetchDates() {
  console.log("FETCHING DATES")
  return getJson('/api/declarations/dates');
}

// 2) Fetch declarations by date
export function fetchDeclarationsByDate(date) {
  return getJson(`/api/declarations?date=${date}`);
}

// 3) Fetch industries
export function fetchIndustries() {
  return getJson('/api/industries');
}

// 4) Remove selected declarations
export function removeDeclarations(declarationIds) {
  return postJson('/api/declarations/remove', { declaration_ids: declarationIds });
}

// 5) Generate drafts for selected declarations
export function generateDeclarations(declarationIds) {
  return postJson('/api/declarations/generate-emails', { declaration_ids: declarationIds });
}

// 6) Send selected declarations
export function sendDeclarations(declarationIds) {
  return postJson('/api/declarations/send-emails', { declaration_ids: declarationIds });
}

// 7) Fetch paginated "removed" declarations
export function fetchRemovedDeclarations(page, perPage) {
  return getJson(`/api/declarations/bin?page=${page}&per_page=${perPage}`);
}

// 8) Restore a single declaration
export function restoreDeclaration(declId) {
  return postJson(`/api/declarations/restore/${declId}`, {});
}

// 9) Update declaration industry
export function updateDeclarationIndustry(declarationId, industryId) {
  return patchJson(`/api/declarations/${declarationId}`, { industry_id: industryId });
}


// 10) Update agent title
export function updateAgentTitle(agentId, title) {
  return patchJson(`/api/agents/${agentId}`, { title: title });
}

// 11) Check sent drafts
export function checkSentDrafts() {
  return getJson('/api/declarations/check-sent-drafts');
}

// 12) Global refresh of all declarations
export function refreshAllDeclarations() {
  return postJson('/api/declarations/refresh');
}